<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :disabled="disabled"
            multiple
            autoComplete
            :dense="dense"
        />
        
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectTeacherCombo',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        
    },
    watch: {
        
        selected(val){
            
            if(val){
                this.$emit('update:model', val);
            }
        },

        model(val){
            this.selected = val;
        },

    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeachers']),  
        
        async getItems() {

            this.loading = true;

            let payload = {
                column_order: 'name',
                direction: 'asc',
                find_columns: {
                    active: 1,
                    teacher_status_id: 1
                },
                columns: 'id,name',
            }

            await this.ActionFindTeachers(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
        
            if(item){
                
                this.items.push(item);

                if(this.multiple){
                    if(!this.selected){
                        this.selected = [];
                    }
                    this.selected.push(item);
                }else{
                    this.selected = item.id;
                }
                
                this.showForm = false;

            }
        }
    },
    
}
</script>